import AboutUs from './Assets/AboutUs.svg';
import Cristiano from './Assets/Founders/CristianoRugnaldo.svg';
import Elon from './Assets/Founders/ElonBust.svg';
import Warren from './Assets/Founders/WarrenBuyit.svg';

import Engineer from './Assets/CoreСrew/Engineer.svg';
import Strategist from './Assets/CoreСrew/Strategist.svg';
import Alchemist from './Assets/CoreСrew/Alchemist.svg';
import Manager from './Assets/CoreСrew/Manager.svg';
import Relations from './Assets/CoreСrew/Relations.svg';
import Analyst from './Assets/CoreСrew/Analyst.svg';

export default function About() {
    return (
        <>
            <div className="font-custom flex flex-col items-center justify-center">
                <section className="w-full lg:w-3/4 px-4 py-4 text-center">
                    <h1 className="xl:text-9xl lg:text-9xl md:text-9xl sm:text-9xl text-6xl textGreen">About us</h1>
                </section>

                <div className="grid xl:grid-cols-6  items-center justify-center ">

                    <section className="xl:col-span-5 xl:col-start-2 xl:col-end-6 md:col-span-6 m-10 mt-2">
                        <img src={AboutUs} alt="About us" className="w-full h-full object-cover" />
                    </section>

                </div>

                <section className="w-full xl:w-3/4 px-4 py-4 text-center">
                    <h1 className="xl:text-9xl lg:text-9xl md:text-9xl sm:text-9xl text-6xl textGreen">Founders</h1>
                </section>


                <div className="w-full xl:w-3/4 grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-1 gap-8 place-items-center lg:mx-8">
                    {/* Warren */}
                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Warren}
                                alt="Warren"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Warren Buyit
                        </h2>
                    </section>

                    {/* Elon */}
                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Elon}
                                alt="Elon"
                                className="w-full h-full object-cover "
                            />
                        </div>
                        <h2 className="text-5xl  lg:text-7xl mt-4">
                            Elon Bust
                        </h2>
                    </section>

                    {/* Cristiano */}
                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Cristiano}
                                alt="Cristiano"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl  lg:text-7xl mt-4">
                            Cristiano Rugnaldo
                        </h2>
                    </section>
                </div>

                <section className="w-full xl:w-3/4 px-4 py-4 text-center">
                    <h1 className="xl:text-9xl lg:text-9xl md:text-9xl sm:text-9xl text-6xl curveLine">Core Crew</h1>
                </section>


                <div className="w-full xl:w-3/4 grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 gap-8 place-items-center lg:mx-8 mb-10">

                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Engineer}
                                alt="Engineer"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Chief Liquidity
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Engineer
                        </h2>
                    </section>

                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Strategist}
                                alt="Strategist"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Lead Meme
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Strategist
                        </h2>
                    </section>

                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Manager}
                                alt="Manager"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            FOMO Operations
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Manager
                        </h2>
                    </section>


                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Analyst}
                                alt="Analyst"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            On-Chain Research
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Analyst
                        </h2>
                    </section>

                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Relations}
                                alt="Relations"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Government
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Relations Liaison
                        </h2>
                    </section>
                    <section className="flex flex-col items-center text-center">
                        <div className="w-48 h-auto sm:w-56 sm:h-auto md:w-64 md:h-auto lg:w-72 lg:h-auto xl:w-80 xl:h-auto">
                            <img
                                src={Alchemist}
                                alt="Alchemist"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            HYPE Product
                        </h2>
                        <h2 className="text-5xl lg:text-7xl mt-4">
                            Alchemist
                        </h2>
                    </section>


                </div>
            </div>
        </>
    );
}